<template>
  <div>
    <div class="px-5">
      <div class="text-h4 font-weight-black">Teman Bakat Partnership</div>
      <div style="font-size: 10px">Last updated: April 15, 2021</div>
    </div>
    <div class="px-5 my-5">
      <!-- <v-card
                class="mx-auto"
                max-width="344"
                outlined
            >
                <v-list-item three-line>
                    <v-list-item-avatar
                        tile
                        size="80"
                        color="grey"
                    ></v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-subtitle>Teman Bakat Partnership</v-list-item-subtitle>
                        <v-list-item-title class="text-h5 mb-1">
                        Sekolah
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                
            </v-card>

            <v-card
                class="mx-auto"
                max-width="344"
                outlined
            >
                <v-list-item three-line>
                    <v-list-item-avatar
                        tile
                        size="80"
                        color="grey"
                    ></v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-subtitle>Teman Bakat Partnership</v-list-item-subtitle>
                        <v-list-item-title class="text-h5 mb-1">
                        Perusahaan
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                
            </v-card>

            <v-card
                class="mx-auto"
                max-width="344"
                outlined
            >
                <v-list-item three-line>
                    <v-list-item-avatar
                        tile
                        size="80"
                        color="grey"
                    ></v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-subtitle>Teman Bakat Partnership</v-list-item-subtitle>
                        <v-list-item-title class="text-h5 mb-1">
                        Psikolog & Biro Psikologi
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                
            </v-card>

            <v-card
                class="mx-auto"
                max-width="344"
                outlined
            >
                <v-list-item three-line>
                    <v-list-item-avatar
                        tile
                        size="80"
                        color="grey"
                    ></v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-subtitle>Teman Bakat Partnership</v-list-item-subtitle>
                        <v-list-item-title class="text-h5 mb-1">
                        Course
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                
            </v-card>

            <v-card
                class="mx-auto"
                max-width="344"
                outlined
            >
                <v-list-item three-line>
                    <v-list-item-avatar
                        tile
                        size="80"
                        color="grey"
                    ></v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-subtitle>Teman Bakat Partnership</v-list-item-subtitle>
                        <v-list-item-title class="text-h5 mb-1">
                        Coach & Trainer
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                
            </v-card> -->
    </div>
  </div>
</template>
<script>
export default {
  name: "Partnership",
};
</script>
